import React from "react";
import styles from "./SectionFour.module.css";
import Contact from "../../Contact/Contact";

function SectionFour(props) {
  return (
    <div className={styles.sectionFour}>
      <Contact />
    </div>
  );
}

export default SectionFour;
